var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveBot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 135,
    viewBox: "0 0 720 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1076.18 183.701C1472.44 183.701 1429.38 38.4188 1786.7 38.4188C1937.32 80.9494 1907.48 272.154 1873.74 362.44H486.609C-88.6122 302.86 -1148.17 183.701 -784.619 183.701C-330.184 183.701 -211.116 0.83783 146.661 0.83783C504.437 0.83783 679.927 183.701 1076.18 183.701Z",
    fill: "url(#paint0_linear_1237_1438)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1237_1438",
    x1: 727.136,
    y1: 204.579,
    x2: 31.4786,
    y2: 922.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522513,
    stopColor: "#199BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02628C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBot2);
export default __webpack_public_path__ + "static/media/wave-bot-2.ea9e95a0219ee7151b1f70cd99d64dcc.svg";
export { ForwardRef as ReactComponent };